import { Button, Flex, Text } from "@chakra-ui/react"
import { useSession } from "next-auth/react"
import Link from "next/link"
import { useTranslation } from "next-i18next"
import { appOrigin } from "@/utils/urls"

const AuthActions = ({ marketing = false }: { marketing?: boolean }) => {
  const { t } = useTranslation()
  const { status } = useSession()
  // On the marketing root domain the app lives on another origin; on a
  // workspace subdomain the links must stay on the current tenant.
  const origin = marketing ? appOrigin() : ""

  if (status === "authenticated") {
    return (
      <Link href={`${origin}/`}>
        <Button variant="brand" fontWeight="light">
          {t("home.account")}
        </Button>
      </Link>
    )
  }

  return (
    <>
      <Link href={`${origin}/auth/login`}>
        <Flex
          alignItems="center"
          gap={{ base: 0, sm: 2 }}
          flexDirection={{ base: "column", sm: "row" }}
          fontFamily="GTMaru"
        >
          <Text>{t("home.already_registered")}</Text>
          <Text textDecoration="underline"> {t("home.login")}</Text>
        </Flex>
      </Link>

      <Link href={`${origin}/auth/register`}>
        <Button variant="brand" fontWeight="light">
          {t("home.create_account")}
        </Button>
      </Link>
    </>
  )
}

export default AuthActions
